export default __webpack_public_path__ + "static/media/umbrella.dd7684df.svg";